// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/src/Jzon.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Js_option from "rescript/lib/es6/js_option.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";

function $dot(f, g, a) {
  return Curry._1(f, Curry._1(g, a));
}

var urlRegex = /(([^:\/?#]+):)?((?:\/\/)?([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;

function mapPromiseAll(xs, f) {
  return Promise.all(xs.map(Curry.__1(f)));
}

var $$Error = /* @__PURE__ */Caml_exceptions.create("Utils.Error");

var ErrorWithStack = /* @__PURE__ */Caml_exceptions.create("Utils.ErrorWithStack");

function get_host_from_url(link) {
  return Js_option.getWithDefault(link.slice(0, 30) + "...", Belt_Array.get(Js_option.getWithDefault([], Caml_option.null_to_opt(link.match(urlRegex))), 4)).replace(/^www\./i, "");
}

function decodeWithPromise(data, codec) {
  var decoded = Jzon.decodeWith(data, codec);
  if (decoded.TAG === /* Ok */0) {
    return Promise.resolve(decoded._0);
  }
  var err = decoded._0;
  var tmp;
  if (err.NAME === "SyntaxError") {
    tmp = {
      RE_EXN_ID: $$Error,
      message: err.VAL
    };
  } else {
    var match = err.VAL;
    tmp = {
      RE_EXN_ID: ErrorWithStack,
      message: match[1],
      stack: match[0].toString()
    };
  }
  return Promise.reject(tmp);
}

export {
  $dot ,
  urlRegex ,
  mapPromiseAll ,
  $$Error ,
  ErrorWithStack ,
  get_host_from_url ,
  decodeWithPromise ,
  
}
/* No side effect */
